import React from "react";
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles';

import { useDispatch, useSelector } from "react-redux";

import _ from 'lodash';

//Router
import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";

import { unoTheme, tabs, headerSearch, toogleButton } from '../../../assets/styles/unoTheme'

import { MyTabs, MyTab } from "../../utils/MyTabs";

import ValidationFundsScreen from "./ValidationFundsScreen";
import ValidationTitlesScreen from "./ValidationTitlesScreen";
import ValidationAccountsScreen from "./ValidationAccountsScreen";

import MyToggleSegregationButton from "../../utils/MyToggleSegregationButton";
import ValidationOtherAssetsScreen from "./ValidationOtherAssetsScreen";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
    },
    headerSearch: headerSearch,
    inputSearch: {
        width: "300px",
        background: "white"
    },
    tableTh: {
        fontWeight: 'bold'
    },
    accordionNewClient: {
        marginBottom: theme.spacing(2),
    },
    heading: {
        display: 'flex',
        alignItems: 'center'
    },
    labelHeading: {
        marginTop: '2px'
    },
    rootForm: {
        // '& .MuiTextField-root': {
        //     margin: theme.spacing(1),
        //     width: '25ch',
        // },
        textAlign: "left",
    },
    progressInput: {
        width: '20px !important',
        height: '20px !important',
    },
    myDatePicker: {
        marginTop: '-6px'
    },
    green: {
        color: unoTheme.greenMoney
    },
    tabs: tabs,

    tabsWithRight: {
        display: 'flex',
        flexDirection: 'row',
        paddingRight: theme.spacing(2),
        alignItems: 'center',

        '& .MuiToggleButtonGroup-root': {
            alignItems: 'center',

            '& .MuiToggleButton-label': {
                whiteSpace: 'nowrap'
            }
        }
    },
    toogleButton: toogleButton,



}));

export default function BalancesValidationScreen() {

    const classes = useStyles();
    const history = useHistory();
    const [tabValue, setTabValue] = React.useState(0);
    const clientOn = useSelector(state => state.clientOn)
    const [formats, setFormats] = React.useState(null);
    const handleFormat = (event, newFormats) => {

        console.log("NEW FORMAT: ", newFormats)

        switch (newFormats) {

            case 0:
                break;
            case 1:
                break;
            case 2:
                break;
            case 3:
                break;

        }

        setFormats(newFormats);
    };


    const handleChangeTabValue = (event, newValue) => {

        setTabValue(newValue);

        if (newValue == 0) {
            history.push('/transactions/balancesValidation/funds')
        } else if (newValue == 1) {
            history.push('/transactions/balancesValidation/titles')
        } else if (newValue == 2) {
            history.push('/transactions/balancesValidation/accounts')
        } else if (newValue == 3) {
            history.push('/transactions/balancesValidation/other-assets')
        }

    };

    return (
        <div className={classes.root}>

            <div className={classes.tabsWithRight}>
                <div className={classes.tabs}>

                    <MyTabs
                        value={tabValue}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={handleChangeTabValue}
                        aria-label="disabled tabs example">

                        <MyTab label="Fundos" />
                        <MyTab label="Títulos" />
                        <MyTab label="Contas" />
                        <MyTab label="Outros Ativos" />

                    </MyTabs>

                </div>

                <MyToggleSegregationButton
                    value={formats}
                    handleValue={handleFormat}
                    clientOn={clientOn}
                />

            </div>




            <Switch className={classes.switch}>
                <Route
                    path="/transactions/balancesValidation/funds">
                    <ValidationFundsScreen regime={formats} />
                </Route>
                <Route
                    path="/transactions/balancesValidation/titles">
                    <ValidationTitlesScreen regime={formats} />
                </Route>
                <Route
                    path="/transactions/balancesValidation/accounts">
                    <ValidationAccountsScreen regime={formats} />
                </Route>
                <Route path="/transactions/balancesValidation/other-assets">
                    <ValidationOtherAssetsScreen regime={formats} />
                </Route>
            </Switch>



        </div>
    );
}



